import React from "react";
import { styled } from "@mui/styles";
import { CssBaseline, Paper } from "@mui/material";
import Header from "../components/Header";
import GlobalStyles from "@mui/material/GlobalStyles";

const GlobalStyle = () =>
    <GlobalStyles
        styles={(theme) => ({
            'html, body, #root': {
                height: '100%'
            },
            body: {
                background: theme.body.background
            },
            '.MuiCardHeader-action .MuiIconButton-root': {
                padding: '4px',
                width: '28px',
                height: '28px',
            }
        })}
    />;

const Root = styled('div')({
    display: 'flex',
    minHeight: '100vh'
});

const AppContent = styled('div')({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
});

const MainContent = styled(Paper)(({ theme }) => ({
    flex: 1,
    background: theme.body.background,
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
        flex: 'none'
    },
    '.MuiPaper-root .MuiPaper-root': {
        boxShadow: 'none'
    },
}));

function AuthLayout({ children }) {
    return (
        <Root>
            <CssBaseline />
            <GlobalStyle />
            <AppContent>
                <Header isMinimal />
                <MainContent>{children}</MainContent>
            </AppContent>
        </Root>
    );
}

export default AuthLayout;
